module.exports = {"532501001":"城区街道","532501002":"沙甸街道","532501003":"大屯街道","532501004":"锡城街道","532501103":"鸡街镇","532501106":"老厂镇","532501107":"卡房镇","532501108":"蔓耗镇","532501202":"贾沙乡","532501203":"保和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532501.json
// module id = 2760
// module chunks = 0